import {FC, useState} from 'react'
import {useFormContext, useWatch} from 'react-hook-form'
import {CleaningActivitiesTable} from '../table/cleaning-activities'
import {MULTI_USER_CREW_SERVICES} from '../../../../services/multi-user-crew.service'
import {ShowSnackBar} from '../../../../../../util/functions'
import Swal from 'sweetalert2'
import {KTableProvider} from '../../../../../../contexts/KTableProvider'
import {ModalCleaningActivities} from '../modal/cleaning-activity'

interface Props {
  prevStep: () => void
  nextStep: () => void
  stepper: any
  goToFirstStep: () => void
  goToStep: (index: number) => void
}

export const ScanningStep: FC<Props> = ({prevStep, nextStep, stepper, goToFirstStep, goToStep}) => {
  const {
    // register,
    setValue,
    watch,
    // control,
    // formState: {errors},
    // setError,
  } = useFormContext()

  const census = useWatch({name: 'census'})
  const [showCleaningActivities, setShowCleaningActivities] = useState(false)
  const activitiesCompleted = useWatch({name: 'ActividadesCompletadas'})
  const [finish, setFinish] = useState(false)
  // const activitiesCompleted = false

  const handlePrev = () => {
    if (census) {
      prevStep() // Si es censo, va hacia atrás normalmente (a Censo)
    } else {
      goToStep(3) // Si no es censo, va a Programación (step 3, índice 2)
    }
  }

  const handleFinish = async () => {
    try {
      setFinish(true)

      if (activitiesCompleted) {
        const {data: finishResponse} = await MULTI_USER_CREW_SERVICES.finishScan({
          EscaneoId: watch('EscaneoId'),
          ActividadesCompletadas: activitiesCompleted,
        })

        if (!finishResponse.error) {
          ShowSnackBar('Proceso finalizado correctamente', 'success')
        } else {
          ShowSnackBar(finishResponse.message || 'Error al finalizar el proceso', 'error')
        }
      } else {
        const result = await Swal.fire({
          title: '¿Estás seguro?',
          html: `
          <div>
            <div>De finalizar el proceso, aún quedan actividades pendientes por escanear.</div>
            <div class="mt-4 w-100 d-flex justify-content-center">
              <button type="button" id="extra-button" class="sdx_btn justify-content-center">
                Ver actividades pendientes
              </button>
            </div>
          </div>
        `,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Si, finalizar',
          confirmButtonColor: 'var(--kt-primary)',
          cancelButtonText: 'No',
          showLoaderOnConfirm: true,
          allowOutsideClick: () => !Swal.isLoading(),
          didOpen: () => {
            const button = document.getElementById('extra-button')

            button?.addEventListener('click', () => {
              setShowCleaningActivities(true)
              Swal.close()
            })
          },
        })

        if (result.isConfirmed) {
          const {data: finishResponse} = await MULTI_USER_CREW_SERVICES.finishScan({
            EscaneoId: watch('EscaneoId'),
            ActividadesCompletadas: activitiesCompleted,
          })

          if (!finishResponse.error) {
            ShowSnackBar('Proceso finalizado correctamente', 'success')
          } else {
            ShowSnackBar(finishResponse.message || 'Error al finalizar el proceso', 'error')
          }

          Swal.close()
        }
      }

      // goToFirstStep()
    } catch (error) {
      ShowSnackBar('Error al finalizar el proceso', 'error')
    } finally {
      setFinish(false)
    }
  }

  return (
    <div className='w-100'>
      {/* <div className='pb-10 pb-lg-15'> */}
      {/* <h2 className='fw-bolder d-flex align-items-center text-dark'>Bienvenido</h2> */}
      {/* <div className='fw-bold fs-6'>Porfavor deslice su tarjeta</div> */}
      {/* </div> */}
      <CleaningActivitiesTable />
      <div className='d-flex flex-stack pt-8 justify-content-between'>
        <button
          type='button'
          className='btn btn-sm btn-light-primary me-3'
          data-kt-stepper-action='previous'
          onClick={handlePrev}
        >
          Atras
        </button>
        <button
          type='button'
          className='btn btn-sm btn-primary me-3'
          onClick={handleFinish}
          disabled={finish}
        >
          {!finish && <span className='indicator-label'>Finalizar</span>}
          {finish && (
            <span className='indicator-progress' style={{display: 'block'}}>
              Finalizando...
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          )}
        </button>
      </div>
      <KTableProvider>
        {showCleaningActivities && (
          <ModalCleaningActivities
            show={showCleaningActivities}
            setShow={setShowCleaningActivities}
          />
        )}
      </KTableProvider>
      {/* <pre>{JSON.stringify(watch(), null, 2)}</pre> */}
    </div>
  )
}
